import styled from '@emotion/styled';

const FormWrapper = styled('form')({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
});

export default FormWrapper;
